module.exports = __webpack_public_path__ + "static/media/quality.9bd6f671.svg";